/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconSubtract from '@telus-uds/palette-allium/build/rn/icons/Subtract'
import PaletteIconAdd from '@telus-uds/palette-allium/build/rn/icons/Add'
const theme = {
  appearances: {
    alternative: { type: 'variant', values: [ true, false ] },
    decrease: { type: 'variant', values: [ true ] },
    disabled: { type: 'variant', values: [ true ] },
    focus: { type: 'variant', values: [ true ] },
    hover: { type: 'variant', values: [ true ] },
    increase: { type: 'variant', values: [ true ] },
    pressed: { type: 'variant', values: [ true ] }
  },
  rules: [
    { if: { hover: true }, tokens: { backgroundColor: '#f4f4f7' } },
    {
      if: { pressed: true },
      tokens: { backgroundColor: '#b2b9bf', iconColor: '#676e73' }
    },
    {
      if: { decrease: true },
      tokens: {
        borderBottomLeftRadius: 4,
        borderRightWidth: 0,
        borderTopLeftRadius: 4,
        icon: PaletteIconSubtract
      }
    },
    {
      if: { increase: true },
      tokens: {
        borderBottomRightRadius: 4,
        borderLeftWidth: 0,
        borderTopRightRadius: 4,
        icon: PaletteIconAdd
      }
    },
    {
      if: { focus: true, increase: true },
      tokens: {
        borderBottomWidth: 3,
        borderLeftWidth: 2,
        borderRightWidth: 3,
        borderTopWidth: 3
      }
    },
    {
      if: { decrease: true, focus: true },
      tokens: {
        borderBottomWidth: 3,
        borderLeftWidth: 3,
        borderRightWidth: 2,
        borderTopWidth: 3
      }
    },
    {
      if: { disabled: true },
      tokens: { backgroundColor: '#fafafa', iconColor: '#e3e6e8' }
    },
    {
      if: { alternative: true },
      tokens: { paddingBottom: 12, paddingTop: 12 }
    },
    {
      if: { alternative: true, increase: true },
      tokens: { borderBottomRightRadius: 24, borderTopRightRadius: 24 }
    },
    {
      if: { alternative: true, decrease: true },
      tokens: { borderBottomLeftRadius: 24, borderTopLeftRadius: 24 }
    }
  ],
  tokens: {
    backgroundColor: '#ffffff',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderBottomWidth: 1,
    borderColor: '#676e73',
    borderLeftWidth: 1,
    borderRadius: 0,
    borderRightWidth: 1,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderTopWidth: 1,
    borderWidth: 1,
    icon: null,
    iconColor: '#414547',
    iconSize: 16,
    padding: 16,
    paddingBottom: 16,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 16
  }
}
export default theme
